/*jslint node: true*/
"use strict";

var ko = require("pli/knockout");
var pliObservable = require("pli/forms-knockoutcontrols");


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// "DependentRequiredBehaviour" class
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
function DependentRequiredBehaviour() {
    /// <summary>
    /// Behaviour ensuring a value is specified
    /// </summary>
    this.defer = true;
}

//-------------------------------------------
DependentRequiredBehaviour.prototype.validate = function dependentRequiredBehaviourValidate(value) {
    /// <summary>
    /// Only validate this observable as required
    /// if the specified trigger has expected value.
    /// </summary>
    var trigger = this.behaviourData && this.behaviourData.trigger;
    if (ko.isObservable(trigger)) {
        var currentValue = ko.utils.unwrapObservable(trigger),
            expectedValue = this.behaviourData && this.behaviourData.expectedValue;
        if (currentValue === expectedValue) {
            return pliObservable.behaviours.required.validate(value);
        }
    }
    return null;
};


//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
// Export
//~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

//-------------------------------------------
module.exports = new DependentRequiredBehaviour();



//////////////////
// WEBPACK FOOTER
// ./app/ko-behaviours-dependentrequired/dependentRequired.js
// module id = 497
// module chunks = 49